<template>
    <div>
        <div v-for="(conditionsInGroup, group) in conditionsPerGroup">
            <strong v-if="group === Object.keys(conditionsPerGroup)[0]">Als</strong>
            <strong v-else>Of als</strong>

            <table class="table-borderless table-sm">
                <colgroup>
                    <col style="width:45%"/>
                    <col style="width:10%"/>
                    <col style="width:45%"/>
                </colgroup>
                <tr v-for="condition in conditionsInGroup">
                    <td>
                        {{ condition.condition_class_display_name }}
                    </td>
                    <td>
                        <span v-if="condition.value !== null">{{ condition.operator }}</span>
                    </td>
                    <td>
                        <span v-if="condition.value !== null">{{ condition.value }}</span>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "TriggerConditionsView",

    props: {
        resultRow: {required: true},
    },

    computed: {
        conditionsPerGroup() {
            return _.groupBy(this.resultRow.conditions, (condition) => condition.group_identifier)
        },
    }
}
</script>
